import { useEffect, useState } from 'react';

export type QuoteParams = {
  endpoint: string;
  model?: string;
  minHeight?: number;
  duration?: number;
};

// Fetches the credit cost for a prospective job from /api/v1/pricing/quote so
// the UI can show it before submit. Returns null while loading or on error
// (the caller just omits the suffix in that case). Re-fetches whenever any
// parameter changes.
export function usePriceQuote(params: QuoteParams): number | null {
  const [credits, setCredits] = useState<number | null>(null);
  const { endpoint, model, minHeight, duration } = params;

  useEffect(() => {
    let cancelled = false;
    const q = new URLSearchParams({ endpoint });
    if (model) q.set('model', model);
    if (minHeight != null) q.set('min_height', String(minHeight));
    if (duration != null) q.set('duration', String(duration));

    fetch(`/api/v1/pricing/quote?${q.toString()}`, { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!cancelled) setCredits(d && typeof d.credits === 'number' ? d.credits : null);
      })
      .catch(() => {
        if (!cancelled) setCredits(null);
      });

    return () => {
      cancelled = true;
    };
  }, [endpoint, model, minHeight, duration]);

  return credits;
}
